var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: "fancafe_" + _vm.tab, attrs: { id: "daumContent", role: "main" } },
    [
      _c("div", { attrs: { id: "cSub" } }, [
        _c("div", { staticClass: "feature_fancafe" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "snb_fancafe" }, [
            _c("div", { staticClass: "inner_snb" }, [
              _c("h3", { staticClass: "screen_out" }, [
                _vm._v("팬카페 서브메뉴"),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "list_snb", on: { click: _vm.setTab } }, [
                _c("li", { staticClass: "fandom_snb" }, [_vm._v("팬덤랭킹")]),
                _vm._v(" "),
                _c("li", { staticClass: "cafe_snb" }, [_vm._v("카페")]),
                _vm._v(" "),
                _c("li", { staticClass: "cheer_snb" }, [_vm._v("응원")]),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "screen_out" }, [
                _vm._v("팬카페 안내메뉴"),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "group_links" }, [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "btn_info",
                      attrs: { href: "#none", id: "rankingTip" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.openLayer.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("팬덤랭킹이란?")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.openedLayer === "rankingTip",
                          expression: "openedLayer === 'rankingTip'",
                        },
                      ],
                      staticClass: "layer_info",
                      attrs: { id: "rankingTip_layer" },
                    },
                    [
                      _vm._v(
                        "\n                                팬덤랭킹은 스타 응원하기, 팬카페 활동 점수"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                                (새글, 방문, 가입)를 중요도에 따라 가중치를"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                                적용하여 합산, 반영합니다.\n\n                                "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "link_detail",
                          attrs: {
                            href: "https://cafe.daum.net/supporters/Mhj5/22",
                            target: "_blank",
                          },
                        },
                        [_vm._v("자세히 보기")]
                      ),
                      _vm._v(" "),
                      _c("button", { staticClass: "btn_close ico_cafetop" }, [
                        _vm._v("레이어 닫기"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "btn_info",
                      attrs: { href: "#none", id: "supportTip" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.openLayer.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("지원안내")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.openedLayer === "supportTip",
                          expression: "openedLayer === 'supportTip'",
                        },
                      ],
                      staticClass: "layer_info",
                      attrs: { id: "supportTip_layer" },
                    },
                    [
                      _vm._v(
                        "\n                                공식팬카페로 선정되면"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                                공식 엠블럼, 검색 우선 소개, 응원 위젯 등"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                                다양한 혜택을 제공합니다.\n\n                                "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "link_detail",
                          attrs: {
                            href: "https://cafe.daum.net/supporters/Mhj5/13",
                            target: "_blank",
                          },
                        },
                        [_vm._v("자세히 보기")]
                      ),
                      _vm._v(" "),
                      _c("button", { staticClass: "btn_close ico_cafetop" }, [
                        _vm._v("레이어 닫기"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "cMain" } }, [_c("fancafe-list")], 1),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "slick-list", attrs: { id: "fancafe_pann_wrap" } },
      [
        _c(
          "button",
          {
            staticClass: "slick-prev ico_cafetop",
            attrs: {
              type: "button",
              id: "getPrev",
              "aria-label": "Previous",
              role: "button",
            },
          },
          [_vm._v("Previous")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "slick-next ico_cafetop",
            attrs: {
              type: "button",
              id: "getNext",
              "aria-label": "Next",
              role: "button",
            },
          },
          [_vm._v("Next")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "slideDataWrap" }, [
          _c("div", { attrs: { id: "slideData" } }),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "slick-track",
          attrs: { id: "fancafe_pann", role: "listbox" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }